import { InputNumber } from 'antd';
import type React from 'react';
import { Item, type ItemProperties } from '../item';

type InputP = {
  'data-test-id'?: string;
} & Omit<React.ComponentProps<typeof InputNumber>, 'css'>;

type P = {
  input?: InputP;
  item: ItemProperties;
};

const NumberInput = ({ input, item }: P) => (
  <Item {...item}>
    <InputNumber size="large" {...input} style={{ width: '100%' }} type="number" />
  </Item>
);

export default NumberInput;
